import {TAddress} from "./TAddress";

export enum TOrderLineStatus {
  ONGOING = 'ONGOING',
  VALIDATED = 'VALIDATED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED'
}

export enum TOrderStatus {
  ONGOING = 'ONGOING',
  VALIDATED = 'VALIDATED',
  ERROR = 'ERROR'
}

export interface TOrderLine {
  "@id": string;
  "@type": string;
  id: string;
  mainImageUrl: string;
  name: string;
  odooProductId: number;
  pointsPrice: number;
  quantity: number;
  reference: string;
  vat: number;
  odooOrderName: string;
  odooTrackingReference: string;
  odooTrackingUrl: string;
  createdAt: string;
  updatedAt: string;
  status: TOrderLineStatus;
}

export interface TMonetaryComplement {
  "@type": string;
  "@id": string;
  id: string;
  amount: string;
  currency: string;
  stripePaymentIntent: string;
  createdAt: string;
  updatedAt: string;
}

export interface TOrder {
  "@type": string;
  "@id": string;
  id: string;
  odooOrderName: string;
  deliveryAddress: TAddress;
  invoiceAddress?: TAddress;
  lines: TOrderLine[];
  status: TOrderStatus;
  createdAt: string;
  updatedAt: string;
  monetaryComplement: TMonetaryComplement;
}

export interface TOrderPayment {
  stripeSecret: string;
  paymentIntentId: string;
}
